import './App.css';
import PuzzleScreen from './Screens/PuzzleScreen';

function App() {
  return (
    <div className='app'>
      <PuzzleScreen/>
    </div>
  );
}

export default App;
